import type { ReactNode } from 'react';
import { useLingui } from '@lingui/react/macro';
import { ArrowUpRight, Zap } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from '@worldcoo/ui/components/dialog';

export function ComingSoonDialog(props: {
	children: ReactNode;
	description: string;
	link?: { label: string; href: string };
}) {
	const { t } = useLingui();
	return (
		<Dialog>
			{props.children}
			<DialogContent className="bg-sand rounded-3xl sm:max-w-md">
				<div className="flex flex-col items-start gap-4 p-2">
					<span className="bg-olive/30 text-ink grid size-12 shrink-0 place-items-center rounded-full">
						<Zap className="size-5 fill-current" />
					</span>
					<DialogTitle className="text-ink text-2xl font-semibold tracking-tight">{t`Coming soon!`}</DialogTitle>
					<DialogDescription className="text-ink/70 text-base">{props.description}</DialogDescription>
					{props.link && (
						<a
							href={props.link.href}
							target="_blank"
							rel="noreferrer"
							className="bg-ink mt-2 flex items-center gap-2 rounded-full py-2.5 pr-2.5 pl-5 font-medium text-white transition-opacity hover:opacity-90"
						>
							{props.link.label}
							<span className="grid size-6 place-items-center rounded-full bg-white/15">
								<ArrowUpRight className="size-4" />
							</span>
						</a>
					)}
				</div>
			</DialogContent>
		</Dialog>
	);
}
